import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Card, Button, Image } from 'react-bootstrap';

import { DetailedMoneyDisplay } from './DetailedMoneyDisplay';
import { MoneyDisplay } from '../order-selection/starter-kit-selection/util-starter-kit/MoneyDisplay';
import { useModuleStore } from '../enrollment-process/module-management/model/ModuleStoreHook';
import { EnrollmentOrderItem } from '../order-selection/starter-kit-selection/model/EnrollmentOrderItem';

interface KitGridItemProps {
  item: EnrollmentOrderItem;
  showDetailLink?: boolean;
  customImage?: string;
  newSlMode?: boolean;
  isSubscription?: boolean;
}

export const AdditionalItemCard = observer<KitGridItemProps>(function KitGridItem({
  item,
  showDetailLink = false,
  customImage,
  newSlMode = false,
  isSubscription = false
}: KitGridItemProps) {
  const { t } = useTranslation();
  const image = customImage || item.imageUrl;
  const store = useModuleStore('socialLinkEntry').enrollmentOrderInfo!;
  const getHtml = (text: any) => (text ? text.split('"\r\n\r\n"').toString() : undefined);
  const description = item.description ?? item.shortDescription;
  return (
    <Col key={item.partNumber} md={3} style={{ marginBottom: '20px' }}>
      {!newSlMode && (
        <div>
          <Card style={{ minHeight: '340px' }}>
            <div className="text-left bg-primary">
              <p className="text-white header-card-text m-1 h-56">{item.name}</p>
            </div>
            <Card.Body className="text-center">
              <span>
                <Button
                  variant="link"
                  // onClick={() => store.showProductInfo(item)}
                >
                  <Image src={image} fluid />
                </Button>
              </span>
              {showDetailLink && (
                <Button
                  variant="link"
                  // onClick={() => store.showProductInfo(kit)}
                >
                  <u>{t('Details')}</u>
                </Button>
              )}
            </Card.Body>
          </Card>
          <strong>
            <span className="pr-1">Price: </span>
            <DetailedMoneyDisplay
              price={item.priceWithTax}
              quantity={item.quantity}
              totalPrice={item.priceWithTaxTotal}
            />
          </strong>
        </div>
      )}

      {newSlMode && (
        <Card
          className={'sl-product-card ' + (isSubscription ? 'sl-subscription' : '')}
          onClick={() => store.showItemInfo(item)}
        >
          <div className="sl-product-image">
            <Image src={image} fluid />
          </div>
          <div className="sl-product-info">
            <p className="sl-product-title">{item.name}</p>
            <p className="sl-product-description" dangerouslySetInnerHTML={{ __html: getHtml(description) }}></p>
            <p className="sl-product-price">
              Price:
              <MoneyDisplay price={item.priceWithTax} newSlMode={newSlMode} />
            </p>
          </div>
        </Card>
      )}
    </Col>
  );
});
